import { SoToSoThua, ToaDo, KetQuaTraCuu } from "./models/tracuuthongtinquyhoach.model";
import { TraCuuThongTinQuyHoachAction } from "./tracuuthongtinquyhoach.action-rule";
import { TraCuuThongTinQuyHoachActionType } from "./tracuuthongtinquyhoach.action-types";

export type TraCuuThongTinQuyHoachModel = {
  soToSoThua: SoToSoThua,
  toaDos: ToaDo[],
  ketQua?: KetQuaTraCuu[]
};

export const traCuuThongTinQuyHoachDefaultState: TraCuuThongTinQuyHoachModel = {
  soToSoThua: {}, toaDos: [
    { ToaDoY: 610670.375, ToaDoX: 1211001.410 },
    { ToaDoY: 610882.043, ToaDoX: 1211101.952 },
    { ToaDoY: 611067.251, ToaDoX: 1210853.243 },
    { ToaDoY: 610887.334, ToaDoX: 1210747.409 },
    { ToaDoY: 610670.375, ToaDoX: 1211001.410 }
  ]
};

function reducer(state: TraCuuThongTinQuyHoachModel = traCuuThongTinQuyHoachDefaultState, action: TraCuuThongTinQuyHoachAction): TraCuuThongTinQuyHoachModel {
  switch (action.type) {
    case TraCuuThongTinQuyHoachActionType.SetSoToSoThua:
      return { ...state, soToSoThua: action.soToSoThua ? action.soToSoThua : traCuuThongTinQuyHoachDefaultState.soToSoThua };
    case TraCuuThongTinQuyHoachActionType.SetToaDo:
      return { ...state, toaDos: action.toaDos || [] };
    case TraCuuThongTinQuyHoachActionType.SetKetQua:
      return { ...state, ketQua: action.ketQua }

    default:
      return state;
  }
}

export default reducer;